import { Building2, Shield, TrendingDown, MapPin } from 'lucide-react';

const benefits = [
  {
    icon: Building2,
    title: 'B2B-focused wholesale supplier',
  },
  {
    icon: Shield,
    title: 'Reliable sourcing & consistent quality',
  },
  {
    icon: TrendingDown,
    title: 'Competitive trade pricing',
  },
  {
    icon: MapPin,
    title: 'UK-based operations',
  },
];

export function WhyChooseUs() {
  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-4xl font-light text-neutral-900 mb-12 text-center">
          Why Choose Us
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {benefits.map((benefit) => (
            <div key={benefit.title} className="flex items-start gap-4 p-6 bg-neutral-50 rounded-sm">
              <benefit.icon className="w-8 h-8 text-neutral-700 flex-shrink-0 mt-1" strokeWidth={1.5} />
              <p className="text-lg text-neutral-800">{benefit.title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
